import React, { useEffect, useRef, useState } from "react";

const CallToActionSection = () => {
  const sectionRef = useRef(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true);
        }
      },
      { threshold: 0.7 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <section ref={sectionRef} className="cta-section py-5">
      <div className="container text-center">
        <h2 className={`fw-bold cta-title ${animate ? "slide-from-top" : ""}`}>
          Drive Innovation Across Your Operations
        </h2>
        <p
          className={`mt-3 cta-description ${
            animate ? "slide-from-bottom" : ""
          }`}
        >
          Discover how our tailored solutions can address your organization's
          unique challenges and
          <br />
          help you achieve operational excellence.
        </p>
        <div className={`mt-4 ${animate ? "slide-from-bottom" : ""}`}>
          <button
            style={{
              backgroundColor: "#020248",
              color: "white",
              borderRadius: "8px",
              padding: "8px 16px",
              fontSize: "15px",
              border: "0 solid transparent",
            }}
          >
            Contact Us Today
          </button>
        </div>
      </div>
    </section>
  );
};

export default CallToActionSection;
